import {twMerge} from '../../../common/twMerge';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {StaticImage} from '../../atoms/StaticImage/StaticImage';
import {StaticImageType} from '../../atoms/StaticImage/StaticImageType.enum';
import {Text} from '../../atoms/Text/Text';
import {ArrowDirection} from './ArrowDirection.enum';
import {TooltipProps} from './TooltipProps.interface';

export function Tooltip({
  text,
  arrowDirection,
  showTooltip,
  isTailEnd,
  onClickTooltipCancel,
  className,
  ...props
}: TooltipProps) {
  return (
    <div
      className={twMerge(
        'flex items-center',
        (arrowDirection === ArrowDirection.Top ||
          arrowDirection === ArrowDirection.Bottom) &&
          isTailEnd &&
          'flex-col items-end',
        (arrowDirection === ArrowDirection.Top ||
          arrowDirection === ArrowDirection.Bottom) &&
          !isTailEnd &&
          'flex-col items-center',
        !showTooltip && 'hidden',
        className
      )}
      {...props}
    >
      {(arrowDirection === ArrowDirection.Left ||
        arrowDirection === ArrowDirection.Top) && (
        <StaticImage
          imageType={ARROW_DIRECTION_IMAGE_TYPE_MAP[arrowDirection]}
          className={
            arrowDirection === ArrowDirection.Top && isTailEnd
              ? 'mr-8pxr'
              : undefined
          }
        />
      )}
      <div className="relative flex items-center justify-between rounded-4pxr bg-static-point-blue p-8pxr pr-28pxr">
        <Text className="font-x-small1-bold whitespace-pre text-static-mono-white">
          {text}
        </Text>
        <Icon
          type={IconType.ButtonCloseSolidSStatic}
          className="absolute top-18pxr right-8pxr h-12pxr w-12pxr cursor-pointer"
          onClick={onClickTooltipCancel}
        />
      </div>
      {(arrowDirection === ArrowDirection.Right ||
        arrowDirection === ArrowDirection.Bottom) && (
        <StaticImage
          imageType={ARROW_DIRECTION_IMAGE_TYPE_MAP[arrowDirection]}
          className={
            arrowDirection === ArrowDirection.Bottom && isTailEnd
              ? 'mr-8pxr'
              : undefined
          }
        />
      )}
    </div>
  );
}

const ARROW_DIRECTION_IMAGE_TYPE_MAP: {
  [key in ArrowDirection]: StaticImageType;
} = {
  [ArrowDirection.Bottom]: StaticImageType.TooltipTailDownStatic,
  [ArrowDirection.Top]: StaticImageType.TooltipTailUpStatic,
  [ArrowDirection.Left]: StaticImageType.TooltipTailLeftStatic,
  [ArrowDirection.Right]: StaticImageType.TooltipTailRightStatic,
};
